import React from "react";
import {
  Dialog,
  Box
} from "@mui/material";
import { styled } from "@mui/material/styles"; 
import "./style.scss";
import { images } from "../../constants";

const StyledDialog = styled(Dialog)(() => ({
  '& .MuiDialog-container': {
    padding: '0 16px',
  },
  '& .MuiDialog-paperFullWidth': {
    minWidth: '100%',
  },
  '& .MuiDialog-paperScrollPaper': {
    maxHeight: '100%',
    backgroundColor: 'transparent',
  },
  '& .MuiDialog-root': {
    maxWidth: '23.5rem',
    marginInline: 'auto',
  },
}));

const GiveawayAlert = ({ handleClose, isOpen, sourceImg }) => {
  return (
    <StyledDialog
      open={isOpen}
      fullWidth
      PaperProps={{ style: { borderRadius: "0", boxShadow: "none" },  }}
    >
      <Box
        sx={{
          position: "absolute",
          right: "0.5rem",
          top: "0.5rem",
          cursor: "pointer",
        }}
      >
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          onClick={handleClose}
        >
          <path
            opacity="0.9"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0H32V32H0V0Z"
            fill="#032954"
          />
          <path
            d="M25.3337 6.6665L6.66699 25.3332"
            stroke="#DDF75B"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.66699 6.6665L25.3337 25.3332"
            stroke="#DDF75B"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </Box>

      <div className="c-CNY">
        <img src={images[sourceImg]} alt="Popup Banner" />
      </div>
    </StyledDialog>
  );
};

export default GiveawayAlert;
